import { render, staticRenderFns } from "./DeliveryMethodInstanceList.vue?vue&type=template&id=4cbaa70a"
import script from "./DeliveryMethodInstanceList.vue?vue&type=script&lang=js"
export * from "./DeliveryMethodInstanceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports